// Single source of truth for the API origin.
//
// API_BASE_URL is inlined by Parcel at build time; each environment's build
// sets it (see .github/workflows/azure-static-web-apps-*.yml). The fallbacks
// preserve the historical behavior when the variable is not provided.
export const API_BASE_URL: string =
  process.env.API_BASE_URL ??
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:9090'
    : 'https://factimize-api-master.azurewebsites.net');
